/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { AgentKb } from "App/IOC/Services";

export default {
    Exchanges: AgentKb.Exchanges,
    Conversations: AgentKb.Conversations,
    Conversation: AgentKb.Conversation,
    Usage: AgentKb.Usage
};
